import { AssetMarket } from '../enums/asset-market.enum';
import { Event } from './event.model';

export interface AssetType {
  name: string;
  defaultCalibration: {
    fanSpeed1: number;
    fanSpeed10: number;
    pumpSpeed1: number;
    pumpSpeed2: number;
    pumpSpeed3: number;
  };
  defaultEvents: Event[];
  targetOutput: {
    fanSpeed1: {
      value: number;
    };
    fanSpeed10: {
      value: number;
    };
    pumpSpeed1: {
      min: number;
      max: number;
    };
    pumpSpeed2: {
      min: number;
      max: number;
    };
    pumpSpeed3: {
      min: number;
      max: number;
    };
  };
  healthyRange: {
    pumpCurrent: { min: number; max: number };
    fanCurrent: { min: number; max: number };
    mcuTemp: { min: number; max: number };
  };
  latestFirmwareVersion: string;
  market: AssetMarket;
}
